import React, { useEffect, useState } from 'react';
import { listRecentlyDeleted, restoreRecentlyDeleted } from '../../api/plottrack';
import {
  RECENTLY_DELETED,
  RECENTLY_DELETED_EMPTY,
  RECENTLY_DELETED_PUT_BACK,
} from '../../utils/writerCopy';

/** Scenes and Notes from the last 30 days. Restore puts the same record back. */
export default function RecentlyDeleted({ storyId, onRestored }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    listRecentlyDeleted(storyId)
      .then((data) => {
        if (live) setItems(data?.items || []);
      })
      .catch(() => {
        if (live) setError('Recently deleted could not be loaded.');
      });
    return () => { live = false; };
  }, [storyId]);

  const putBack = async (item) => {
    setError('');
    try {
      await restoreRecentlyDeleted(storyId, item.kind, item.id);
      setItems((prev) => (prev || []).filter((row) => row.id !== item.id));
      if (onRestored) await onRestored(item);
    } catch (err) {
      setError(err?.message || 'That item could not be put back.');
    }
  };

  return (
    <div className="undo-recent" role="region" aria-label={RECENTLY_DELETED}>
      <p className="undo-recent__title">{RECENTLY_DELETED}</p>
      {error ? <p role="alert">{error}</p> : null}
      {items === null ? <p>Loading.</p> : null}
      {items && items.length === 0 ? <p>{RECENTLY_DELETED_EMPTY}</p> : null}
      {items && items.length > 0 ? (
        <ul className="undo-recent__list">
          {items.map((item) => (
            <li key={`${item.kind}-${item.id}`}>
              <span>{item.name || (item.kind === 'note' ? 'Note' : 'Scene')}</span>
              <button type="button" className="undo-msg__btn" onClick={() => { void putBack(item); }}>
                {RECENTLY_DELETED_PUT_BACK}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
